import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpsertModuleCompletionMutationVariables = Types.Exact<{
  object: Types.Learning_Module_Completions_Insert_Input;
}>;


export type UpsertModuleCompletionMutation = { __typename?: 'mutation_root', insert_learning_module_completions_one?: { __typename?: 'learning_module_completions', id: number, module_key: string, module_id?: number | null, completed_at: string } | null };


export const UpsertModuleCompletionDocument = gql`
    mutation UpsertModuleCompletion($object: learning_module_completions_insert_input!) {
  insert_learning_module_completions_one(
    object: $object
    on_conflict: {constraint: learning_module_completions_user_id_module_key_key, update_columns: []}
  ) {
    id
    module_key
    module_id
    completed_at
  }
}
    `;
export type UpsertModuleCompletionMutationFn = Apollo.MutationFunction<UpsertModuleCompletionMutation, UpsertModuleCompletionMutationVariables>;

/**
 * __useUpsertModuleCompletionMutation__
 *
 * To run a mutation, you first call `useUpsertModuleCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModuleCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModuleCompletionMutation, { data, loading, error }] = useUpsertModuleCompletionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertModuleCompletionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertModuleCompletionMutation, UpsertModuleCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertModuleCompletionMutation, UpsertModuleCompletionMutationVariables>(UpsertModuleCompletionDocument, options);
      }
export type UpsertModuleCompletionMutationHookResult = ReturnType<typeof useUpsertModuleCompletionMutation>;
export type UpsertModuleCompletionMutationResult = Apollo.MutationResult<UpsertModuleCompletionMutation>;
export type UpsertModuleCompletionMutationOptions = Apollo.BaseMutationOptions<UpsertModuleCompletionMutation, UpsertModuleCompletionMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/learningCenter/queries/upsertModuleCompletion.mutation.gql}
 */
export async function upsertModuleCompletion(
  variables: UpsertModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertModuleCompletionMutation['insert_learning_module_completions_one']>
export async function upsertModuleCompletion(
  variables: UpsertModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertModuleCompletionMutation>
export async function upsertModuleCompletion(
  variables: UpsertModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertModuleCompletionMutation['insert_learning_module_completions_one'] | UpsertModuleCompletionMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertModuleCompletionMutation>(
    UpsertModuleCompletionDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_learning_module_completions_one
}